/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Digitell_Nein12Inputs */

const en__field_enum_digitell_nein12 = /** @type {(inputs: _Field_Enum_Digitell_Nein12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No`)
};

const de__field_enum_digitell_nein12 = /** @type {(inputs: _Field_Enum_Digitell_Nein12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nein`)
};

/**
* | output |
* | --- |
* | "No" |
*
* @param {_Field_Enum_Digitell_Nein12Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_digitell_nein12 = /** @type {((inputs?: _Field_Enum_Digitell_Nein12Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Digitell_Nein12Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_digitell_nein12(inputs)
	return de__field_enum_digitell_nein12(inputs)
});
export { _field_enum_digitell_nein12 as "_field_enum_DIGITELL_NEIN" }